export const calculatePlayerRating = (player: { skills?: number; effort?: number; stamina?: number }): number => {
  const skills = player?.skills ?? 75;
  const effort = player?.effort ?? 75;
  const stamina = player?.stamina ?? 75;
  return Math.round((skills + effort + stamina) / 3);
}; 